<div class="nav-top tlhex">
	<div class="nav-left-side" ngbDropdown container="body" placement="bottom-start">
		<span data-testid="SUBSYS7_NAVBAR_ACCOUNT_BTN" class="material-icons" ngbDropdownToggle>account_circle</span>
		<span data-testid="SUBSYS7_NAVBAR_USER_TXT" class="welcome-text" [title]="username()">
			{{ labels().NAVBAR_COMPONENT_WELCOME }} {{username()}}
		</span>

		<div class="dropdown-menu" ngbDropdownMenu>
			<div data-testid="SUBSYS7_NAVBAR_EULA_BTN" class="dropdown-item text-truncate"
				[title]="labels().NAVBAR_COMPONENT_EULA_POLICY" (click)="openLegalTerms()" (keypress)="openLegalTerms()">
				{{ labels().NAVBAR_COMPONENT_EULA_POLICY }}
			</div>
			<div data-testid="SUBSYS7_NAVBAR_ABOUT_BTN" class="dropdown-item text-truncate"
				[title]="labels().NAVBAR_COMPONENT_ABOUT" (click)="openAboutPage()" (keypress)="openAboutPage()">
				{{ labels().NAVBAR_COMPONENT_ABOUT }}
			</div>
			@if (envName != 'production') {
			<div data-testid="SUBSYS7_NAVBAR_VERSION_TXT" class="simple-text">{{buildVersion}}</div>
			}
			<div data-testid="SUBSYS7_NAVBAR_LOGOUT_BTN" class="dropdown-item text-truncate"
				[title]="labels().NAVBAR_COMPONENT_LOGOUT" (click)="logout()" (keypress)="logout()">
				{{ labels().NAVBAR_COMPONENT_LOGOUT }}
			</div>
		</div>
	</div>

	<div class="wrapper-info">
		@let patientNumber = plan()?.patient?.number;
		<div data-testid="SUBSYS7_NAVBAR_PATID_TXT" class="box-info" [title]="patientNumber">
			<span>{{labels().NAVBAR_COMPONENT_PATIENT_ID}}</span> {{patientNumber}}
		</div>
		@let planNumber = plan()?.isReceived ? (plan()!.number | replaceLongLeg) : plan()?.number;
		<div data-testid="SUBSYS7_NAVBAR_PLANID_TXT" class="box-info" [title]="planNumber">
			<span>{{labels().NAVBAR_COMPONENT_PLAN_ID}}</span> {{planNumber}}
		</div>
		@let planSide = plan()?.side | anatomicalSideLabel;
		<div data-testid="SUBSYS7_NAVBAR_PLANSIDE_TXT" class="box-info" [title]="planSide">
			<span>{{labels().NAVBAR_COMPONENT_PLAN_SIDE}}</span> {{planSide}}
		</div>
		@let boneType = plan()?.boneType | boneTypeLabel;
		<div data-testid="SUBSYS7_NAVBAR_PLANBONE_TXT" class="box-info" [title]="boneType">
			<span>{{labels().NAVBAR_COMPONENT_PLAN_BONE_TYPE}}</span> {{boneType}}
		</div>
		<div data-testid="SUBSYS7_NAVBAR_PLANSTEP_TXT" class="box-info" [title]="planStepLabel()">
			<span>{{labels().NAVBAR_COMPONENT_PLAN_STEP}}</span> {{planStepLabel()}}
		</div>
		@let planType = plan()?.type | planTypeLabel;
		<div data-testid="SUBSYS7_NAVBAR_PLANTYPE_TXT" class="box-info" [title]="planType">
			<span>{{labels().NAVBAR_COMPONENT_PLAN_TYPE}}</span> {{planType}}
		</div>
	</div>
	<div class="nav-right-side position-static" ngbDropdown container="body" placement="bottom"
		(openChange)="getGuideList($event)">

		@if (isWatermarkVisible()) {
		<div class="wrapper-demo-text">
			<span data-testid="SUBSYS7_NAVBAR_DEMO_TXT" class="demo-text" [title]="labels().WATERMARK_DEMO">
				{{ labels().WATERMARK_DEMO }}
			</span>
			<span data-testid="SUBSYS7_NAVBAR_LOGO_TXT" class="logo-text">{{ labels().APP_LOGO_TEXT }}</span>
		</div>
		} @else {
		<span data-testid="SUBSYS7_NAVBAR_LOGO_TXT" class="logo-text">{{ labels().APP_LOGO_TEXT }}</span>
		}

		@if(isSaveVisible) {
		<div data-testid="SUBSYS7_NAVBAR_SAVE_BTN" class="nav-top-link" [class.disabled]="isReadOnly()"
			[title]="labels().NAVBAR_COMPONENT_SAVE" (click)="save()" (keypress)="save()">
			<i class="material-icons-outlined">save</i>
		</div>
		}

		<div data-testid="SUBSYS7_NAVBAR_GUIDE_BTN" class="nav-top-link" ngbDropdownToggle
			[title]="labels().NAVBAR_COMPONENT_GUIDE">
			<img class="ifu-icon" alt="ifu icon">
		</div>

		<div data-testid="SUBSYS7_NAVBAR_HELP_BTN" class="nav-top-link" [title]="labels().NAVBAR_COMPONENT_HELP"
			(click)="openHelpModal()" (keypress)="openHelpModal()">
			<i class="material-icons-outlined">live_help</i>
		</div>

		<div data-testid="SUBSYS7_NAVBAR_BACK_BTN" class="nav-top-link btn btn-primary back"
			[title]="labels().NAVBAR_COMPONENT_BACK_BTN" (click)="openClosingModal()" (keypress)="openClosingModal()">
			{{ labels().NAVBAR_COMPONENT_BACK_BTN }}
		</div>

		<div class="dropdown-menu no-line" ngbDropdownMenu style="max-width: 30rem;">
			<a data-testid="SUBSYS7_NAVBAR_IFUSITE_BTN" [href]="eifuSiteUrl" target="_blank"
				class="dropdown-item text-truncate" [title]="labels().NAVBAR_COMPONENT_LINK_EIFU">
				{{ labels().NAVBAR_COMPONENT_LINK_EIFU }}
			</a>
			@for (guide of guideList; track guide) {
			@let guideLabel = labels()[guide.labelKey];
			<div class="dropdown-item text-truncate" [title]="guideLabel" (click)="openGuide(guide.path)"
				(keypress)="openGuide(guide.path)">
				{{ guideLabel }}
			</div>
			}
		</div>

	</div>
</div>